import axios from "axios";
import {
  API_END_POINT,
  API_DOMAIN,
  EXPRIRES_ACCESS_TOKEN,
  EXPRIRES_REFRESH_TOKEN,
} from "./Api";
import Cookies from "js-cookie";
import { Alertwarning, EncryptData, FormatDateJson } from "../Utils";

export const axiosClient = {
  API_Login: (data) => {
    return axios
      .post(API_END_POINT + "/login_customer", data, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => res.data);
  },
  API_Token: (data) => {
    return axios.post(API_DOMAIN + "/oauth/get_token", data, {
      headers: {
        "content-type": "application/x-www-form-urlencoded",
      },
    });
  },
};

export const getToken = async (userInfo) => {
  console.log("🚀 ~ getToken ~ userInfo:", userInfo)
  try {
    // Validate input
    if (!userInfo?.Token) {
      throw new Error("Missing required user information");
    }

    // Helper function for expiry time calculation
    const calculateExpiryTime = (days = 0, minutes = 0) => {
      const now = new Date();
      return new Date(now.getTime() + (days * 24 * 60 + minutes) * 60 * 1000);
    };

    // Common cookie options
    const cookieOptions = {
      path: "/",
      secure: process.env.NODE_ENV === "production",
      sameSite: "Strict",
    };

    // Get token from API
    const tokenRes = await axiosClient.API_Token(
      `grant_type=client_credentials&client_id=${userInfo.Token}&user_id=${userInfo?.Account_Id}`
    );

    const { data: res } = tokenRes;
    if (res.error) {
      throw new Error(res.error_description || res.error);
    }

    // Calculate expiry times
    const accessTokenExpiry = calculateExpiryTime(0, EXPRIRES_ACCESS_TOKEN);
    const refreshTokenExpiry = calculateExpiryTime(EXPRIRES_REFRESH_TOKEN);

    // Set user info cookie
    Cookies.set(
      "UserInfor",
      EncryptData({
        ...userInfo,
        loginTime: FormatDateJson(new Date(), 8),
        loginVersion: "1.0.0",
        expireAt: refreshTokenExpiry.getTime(),
      }),
      {
        ...cookieOptions,
        expires: refreshTokenExpiry,
      }
    );

    // Set client ID
    Cookies.set("client_id", userInfo.Token, {
      ...cookieOptions,
      expires: refreshTokenExpiry,
    });

    // Set access token
    Cookies.set("accessToken", res.access_token, {
      ...cookieOptions,
      expires: accessTokenExpiry,
    });

    // Set refresh token
    Cookies.set("refreshToken", res.refresh_token, {
      ...cookieOptions,
      expires: refreshTokenExpiry,
    });

    // Store token expiry time
    localStorage.setItem(
      "tokenExpiryTime",
      accessTokenExpiry.getTime().toString()
    );
    sessionStorage.setItem("_e_d_r_f", res.refresh_token);

    // Debug logging in development
    if (process.env.NODE_ENV !== "production") {
      console.log("Token setup completed:", {
        accessTokenExpiry,
        refreshTokenExpiry,
        userInfo: userInfo.Id || userInfo.CustomerID,
      });
    }

    return true;
  } catch (error) {
    console.error("Token setup failed:", error);
    Alertwarning(error.message);
    return false;
  }
};

// export const getToken = async (userInfo) => {
//   function expireTimeGetRT() {
//     const now = new Date();
//     const date = new Date(now);
//     date.setDate(now.getDate() + 1); // Ngày mai, nhưng giữ nguyên giờ
//     return date;
//   }

//   const tokenRes = await axiosClient.API_Token(
//     `grant_type=client_credentials&client_id=${
//       userInfo?.Id || userInfo?.CustomerID
//     }`
//   );
//   const res = tokenRes.data;
//   if (res.error) {
//     Alertwarning(res.error_description || res.error);
//     return;
//   }
//   // settoken ở đây
//   const expireTimeAT = new Date(
//     new Date().getTime() + EXPRIRES_ACCESS_TOKEN * 60 * 1000
//   );
//   const expireTime =
//     new Date().getTime() + EXPRIRES_REFRESH_TOKEN * 24 * 60 * 60 * 1000;
//   Cookies.set(
//     "UserInfor",
//     EncryptData({
//       ...userInfo,
//       loginTime: FormatDateJson(new Date(), 8),
//       loginVersion: "1.0.0",
//       expireAt: expireTime, // Lưu thời gian hết hạn
//     }),
//     { expires: expireTimeGetRT(), path: "/" } // Lưu cookie trong 7 ngày
//   );

//   const secure = process.env.NODE_ENV === "production";
//   Cookies.set("client_id", userInfo?.Id || userInfo?.CustomerID, {
//     expires: expireTimeGetRT(), // Cookie hết hạn sau 7 ngày
//     // secure: true, // Chỉ gửi cookie qua kết nối HTTPS
//     secure: secure,
//     sameSite: "Strict", // Ngăn chặn CSRF bằng cách chỉ gửi cookie từ cùng một trang web
//     path: "/", // Đặt đường dẫn cookie
//   });

//   Cookies.set("accessToken", res?.access_token, { expires: expireTimeAT }); // Lưu cookie trong 1

//   Cookies.set("refreshToken", res?.refresh_token, {
//     expires: expireTimeGetRT(), // Cookie hết hạn sau 7 ngày
//     // secure: true, // Chỉ gửi cookie qua kết nối HTTPS
//     secure: secure,
//     sameSite: "Strict", // Ngăn chặn CSRF bằng cách chỉ gửi cookie từ cùng một trang web
//     path: "/", // Đặt đường dẫn cookie
//   });
//   // Lưu thời gian hết hạn token vào localStorage
//   const expiryTime = new Date().getTime() + EXPRIRES_ACCESS_TOKEN * 60 * 1000; // Thời gian hết hạn tính bằng milliseconds
//   localStorage.setItem("tokenExpiryTime", expiryTime);
//   sessionStorage.setItem("_e_d_r_f", res.refresh_token);
// };
